/**
 * @author       justin.jeong@zumper.com (Justin Jeong)
 * @copyright    Copyright (c) 2020, Zumper
 * @description  hashtagModal action
 */

import type { RentReport } from '@zcode/bizos'
import { createAction } from 'redux-actions'
import { type HASHTAG_TYPES, SET_HASHTAG_TYPE, SET_RENT_REPORT } from '../constants/hashtagModal'

export const setHashtagType = createAction<
  (typeof HASHTAG_TYPES)[keyof typeof HASHTAG_TYPES] | null,
  typeof SET_HASHTAG_TYPE
>(SET_HASHTAG_TYPE)

export const setRentReport = createAction<RentReport | null, typeof SET_RENT_REPORT>(
  SET_RENT_REPORT
)
